import { render, staticRenderFns } from "./card-flight.vue?vue&type=template&id=638aba12&scoped=true"
import script from "./card-flight.vue?vue&type=script&lang=js"
export * from "./card-flight.vue?vue&type=script&lang=js"
import style0 from "./card-flight.vue?vue&type=style&index=0&id=638aba12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638aba12",
  null
  
)

export default component.exports